module.exports = __webpack_public_path__ + "img/6.c17c65a3.png";